import {fromJS, Map} from 'immutable';
import '../libraries';

import {INCREMENT_PENDING, DECREMENT_PENDING} from '../containers/actions';
import * as actions from './actions';

export default function(state = fromJS({elementId: window.uuidv4()}), action) {
    if (state.get('errors') === undefined) {
        state = state.set('errors', new Map({}));
    }
    if (state.get('pending') === undefined) {
        state = state.set('pending', 0);
    }
    if (state.get('isOpen') === undefined) {
        state = state.set('isOpen', false);
    }
    if (action.elementId === state.get('elementId')) {
        switch (action.type) {
        case actions.OPEN:
            state = state.set('isOpen', true);
            break;

        case actions.CLOSE:
            state = state.set('isOpen', false);
            break;

        case actions.SET_ERRORS:
            state = state.set('errors', new Map(action.errors));
            break;
        }
    }
    else {
        switch (action.type) {
        case INCREMENT_PENDING:
            state = state.set('pending', state.get('pending') + 1);
            break;

        case DECREMENT_PENDING:
            state = state.set('pending', state.get('pending') - 1);
            break;
        }
    }
    return state;
}
